<template>
  <div class="home">
    <Cover />
    <About />
    <Value />
    <Credits />
  </div>
</template>

<script>
import About from './about/';
import Value from './value/';
import Credits from './Credits';
import Cover from '../views/Cover.vue';

export default {
  name: 'Home',
  components: { About, Value, Credits, Cover }
};
</script>
